
const setProfileList = (state, profileList) => {
  state.profileList = profileList;
};


export default {
  setProfileList
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js